import React, { createRef } from 'react'
import { Button,Dropdown, Image, Card, Modal, Grid, Icon, Message } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import _ from 'lodash';
import { singleLineText } from '../../../../common/RegexValidation';
import OrgUnitReplaceUserSearchTable from './../ReplaceUserSearchTable';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import LoadingComponent from '../../../../common/LoadingComponent';
import { toastr } from "react-redux-toastr";

let suborgToUpdate = [];
let payload = {};
let inviteSearchObject = {
    firstName: "",
    lastName: "",
    email: ""
}
class DeactivatedMember extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: '',
            loader: false,
            noRecord: false,
            checkValid: true,
            selectedUser: null,
        }

        this.deactivateUserModalClose = this.deactivateUserModalClose.bind(this);
        this.deactivateUser = this.deactivateUser.bind(this);
        this.firstNameRef=createRef();
        this.lastNameRef=createRef();
        this.emailRef=createRef();
    }

    deactivateUserModalClose() {
        dispatch.users.userDeactivateModal(false);
    }
    async componentWillMount(){
        await dispatch.organizationUnit.getOrganizationUsers({
            _id: this.props.selectedOrganisation.id || this.props.selectedOrganisation._id,
        })
        if(this.props.orgUsers && this.props.orgUsers.length > 0) {
            this.setState({selectedUser: this.props.orgUsers.find(user => user.role === "workspaceOwner").accountUserId._id})
        }
    }

    handleReset() {
        document.getElementById("invitationForm").reset();
        dispatch.invite.clearInviteSearchFilter();
        this.setState({ setRole: '', invitationError: null })
        this.setState({ noRecord: false })
        if (!this.state.checkValid) {
            this.setState({ checkValid: true })
        }
        inviteSearchObject = {
            firstName: "",
            lastName: "",
            email: ""
        }

    }
    async deactivateUser() {
        if (!this.state.errorMsg) {
            this.setState({loader: true})
            let payloadArr = []
            let payload = {};
            payload.accountUserId = this.props.userObj._id;
            payload.organizationId = this.props.selectedOrganisation.id;
            payload.accountId = this.props.selectedAccount._id;

            for (const subObj of suborgToUpdate) {
                if (subObj.members) {
                    for (let i = subObj.members.length; i--;) {
                        if (subObj.members[i].accountUserId === this.props.userObj._id) {
                            let index = subObj.members.indexOf(subObj.members[i]);
                            subObj.members.splice(index, 1);
                            payloadArr.push(subObj)
                        }
                    }
                }
            }

            payload.suborgArr = payloadArr;
            payload.orgUniqueId = this.props.orgUniqueId;
            try {
                await dispatch.users.deactivateUserFromOrgAsync(payload);
                await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                dispatch.organizationUnit.showResourecePane(null);
                dispatch.organizationUnit.showDeleteDisabled(false)
                this.setState({loader: false})
            }
            catch (err) {
                err.message = err.message + " If you want to replace this user, please select another user to replace.";
                this.setState({ errorMsg: err.message, loader: false })
            }
        } else {
            let userData = this.props.orgUsers.find(user => user.accountUserId._id === this.state.selectedUser).accountUserId;
            if (userData) {
                let message = (
                    <div className="confirmMessage">
                        <h3>Replace User</h3>
                        <label>
                        {userData.firstName} {userData.lastName}
                        </label>
                        <p>Are you sure that you wish to Replace {this.props.userObj.firstName + ' ' + this.props.userObj.lastName} with {userData.firstName} {userData.lastName}?</p>
                    </div>
                    );
                    toastr.confirm(message, {
                    onOk: async () => {
                        const payload = {
                            userId : this.props.userObj._id,
                            organizationId: this.props.selectedOrganisation._id,
                            accountId : this.props.selectedAccount._id,
                            replaceUserId: userData._id,
                        }
                        await dispatch.users.replaceDeactivateUserFromOrgAsync(payload);
                        dispatch.users.userDeactivateModal(false); 
                    },
                });
            }
        }

    }

    render() {
        const inlineStyle = {
            modal: {
                marginTop: '0',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const userOptions = this.props.orgUsers.filter(user => user.accountUserId._id !== this.props.userObj._id).map(user => ({
            key: user.accountUserId._id,
            value: user.accountUserId._id,
            text: `${user.accountUserId.firstName} ${user.accountUserId.lastName || ''}`,
            content: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src={user.accountUserId.profilePic}
                    alt={`${user.accountUserId.firstName} ${user.accountUserId.lastName || ''}`}
                    style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    marginRight: '8px'
                    }}
                />
                <span>
                    {user.accountUserId.firstName} {user.accountUserId.lastName || ''}
                </span>
                </div>
            )
        }));
        const errorLabel = <div className="customErrorLabel" />;
        suborgToUpdate = _.cloneDeep(this.props.deactUserData.data);

        return (
            <div>
            <LoadingComponent active={this.state.loader || this.props.loadingReplaceDeactivateUserFromOrgAsync} message="Removing User..."/>
            <Modal
                size='small'
                open={this.props.isUserDeactivateModal}
                centered
                style={inlineStyle.modal}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Form noValidate
                    ref={ref => this.form = ref}
                    className="formcyForm"
                    onValidSubmit={this.deactivateUser}
                >
                    <Grid className="deleteUserfromUnit" >
                        <Grid.Row columns={2}>
                            <Grid.Column>
                                <h4>Remove Member from Workspace {this.props.selectedOrganisation.name}</h4>
                                <Grid>
                                    <Grid.Column width={3} style={{ margin: "0 0 10px  0" }} >
                                        <ImageAvater user={this.props.userObj} className="w_32 h_32 mar_5" imageStyle="w_32 h_32 mar_5" />
                                    </Grid.Column>
                                    <Grid.Column width={13} className="memberInfo">
                                        <Card.Header>{this.props.userObj.firstName + ' ' + this.props.userObj.lastName}</Card.Header>
                                        <Card.Meta className="email" content={this.props.userObj.email} />
                                        <Card.Meta className="role" content={
                                            this.props.userObj.role === "workspaceOwner"
                                            ? "Workspace Owner"
                                            : this.props.userObj.role
                                        } />

                                    </Grid.Column>
                                </Grid>
                            </Grid.Column>
                            <Grid.Column>
                                <h4>Current Workspace and Role</h4>
                                <div className="currentUserAndRole">
                                    <div >
                                        <Icon name="group" />
                                        <span>{this.props.selectedOrganisation.name}</span>

                                    </div>
                                    <div>
                                        <Icon name="user" />
                                        <span>{
                                            this.props.userObj.role === "workspaceOwner"
                                            ? "Workspace Owner"
                                            : this.props.userObj.role
                                        }</span>
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        {!this.state.errorMsg ?
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <p>Are you sure you want to remove this user?
                            <span className="actionTag"> This action is not reversible</span>
                                    </p>
                                </Grid.Column>
                            </Grid.Row> : ''}

                        {this.state.errorMsg ?
                            <Grid.Row>
                                <Message
                                    color='yellow'
                                    className="inviteWarning"
                                    content={this.state.errorMsg}
                                />
                                <div style={{color:"#63B7F9", margin:"3px", fontWeight: 600}}>Replace User</div>
                                <div style={{ width:"100%", margin: "5px" }}>
                                    <Form noValidate
                                        className="invitationForm"
                                        id='invitationForm'
                                        ref={ref => this.form = ref}
                                    >
                                        <Grid className="inviteForm">
                                            <Grid.Row style={{display:"flex",alignItems:"baseline"}}>
                                                <Grid.Column width={5} style={{display:"flex",flexDirection:"column"}}>
                                                    <label htmlFor='firstName'>Select User
                                                        <span style={{color:"red", position: "relative", top: "-2px", left:"5px"}}>*</span>
                                                    </label>
                                                    <Dropdown
                                                        placeholder='Select User'
                                                        fluid
                                                        selection
                                                        options={userOptions}
                                                        item
                                                        value={this.state.selectedUser}
                                                        onChange={(e, { value }) => this.setState({ selectedUser: value })}
                                                        style={{ marginTop: "5px" }}
                                                    />
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Form>
                                    {/* {this.props.searchUserArr && this.props.searchInviteUserArr && (this.props.searchUserArr.length > 0 || this.props.searchInviteUserArr.length) > 0 ?
                                    <div style={{ maxHeight: "170px", overflowY: "auto", marginTop: "10px" }}>
                                        <OrgUnitReplaceUserSearchTable
                                            searchUserArr={this.props.searchUserArr}
                                            searchInviteUserArr={this.props.searchInviteUserArr}
                                            user={this.props.user} {...this.props}
                                            organizationId={this.props.match.params.workspaceId}
                                            selectedSubOrg={this.props.selectedSubOrg}
                                            handleReset={() => this.handleReset()}
                                            teamDropdownDisableFlag={this.state.teamDropdownDisableFlag}
                                            teamId={this.state.teamId}
                                            selectedOrganisation={this.props.selectedOrganisation}
                                            subOrgs={this.props.subOrgs}
                                        /></div>
                                        : this.state.noRecord && this.state.invitationError === null ?
                                            <Message
                                                color='yellow'
                                                className="inviteWarning">
                                                <p>
                                                    User not found. Please enter details to invite the user.
                                            </p>
                                            </Message>
                                            : ''} */}
                                </div>    
                            </Grid.Row>
                            : ''
                        }
                        <Grid.Row columns={1}>
                            <Grid.Column>
                                <Button floated='right' className="bg-clr-orange bg-blue" type="cancel" id="cancel" >{this.state.errorMsg ? "Remove and Replace" : "Remove"}</Button>
                                <Button floated='right' className="bg-clr-gray" id="submit" onClick={this.deactivateUserModalClose}>Cancel</Button>
                            </Grid.Column>
                        </Grid.Row>

                    </Grid>
                </Form >
            </Modal>
            <Button/>
            </div>
        )
    }

}

export default DeactivatedMember;